import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, CartesianGrid,
} from 'recharts';
import { fmtMoney } from './format';
import { chart } from '../../theme';

// Horizontal bar chart of overtime cost by cost center (top N).
export default function CostCenterChart({ data, selectedKey, onSelect, topN = 15 }) {
  const rows = (data || []).slice(0, topN).map((d) => ({
    ...d,
    // Keep labels short but readable on the axis.
    shortName: d.name.length > 26 ? d.name.slice(0, 25) + '…' : d.name,
  }));

  if (!rows.length) {
    return <div style={s.empty}>No overtime recorded for this period.</div>;
  }

  const height = Math.max(220, rows.length * 34 + 40);

  return (
    <div style={s.wrap}>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={rows} layout="vertical" margin={{ top: 4, right: 70, bottom: 4, left: 8 }}>
          <CartesianGrid horizontal={false} stroke={chart.grid} />
          <XAxis type="number" tickFormatter={fmtMoney} tick={{ fontSize: 11, fill: chart.axisText }} />
          <YAxis
            type="category" dataKey="shortName" width={160}
            tick={{ fontSize: 11, fill: chart.axisTextStrong }} interval={0}
          />
          <Tooltip
            cursor={{ fill: 'rgba(27,42,74,0.05)' }}
            formatter={(v) => [fmtMoney(v), 'Overtime Cost']}
            labelFormatter={(_l, p) => p?.[0]?.payload?.name || ''}
            contentStyle={{ fontSize: '12px', borderRadius: '8px', border: `1px solid ${chart.tooltipBorder}` }}
          />
          <Bar dataKey="ot_amount" radius={[0, 4, 4, 0]} cursor="pointer"
               onClick={(d) => onSelect?.(d.payload)}>
            {rows.map((r) => (
              <Cell key={r.cc_key}
                    fill={r.cc_key === selectedKey ? chart.emphasis : chart.recessive} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

const s = {
  wrap:  { background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '16px' },
  empty: { background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '40px', textAlign: 'center', color: '#9CA3AF', fontSize: '13px' },
};
